module.exports = __webpack_public_path__ + "img/suburban-21.ffc2a31d.png";